'use strict';

import * as THREE from 'three';
import {
    Buildings,
    cardsData,
    isMobile,
    projectMode,
    settingsData,
    threeJsVariables,
} from '../../settings';
import {hideTooltip, updateTooltipPosition, updateTooltipText} from "../flatTooltip/flatTooltip";
import {CardTypes, SelectedObjectType, ViewMode} from "../../common";
import {cylinderFloorNumbersIntersection} from "../cylinderFloorNumbers/cylinderFloorNumbers";
import {
    createMaterialAndSetBaseColor,
    findSelectionAndCrmData,
    flatClick,
    rgbaToHexA,
    userPrevent,
} from '../../functions';
import {changeActiveCardWhenBuildingClick} from "../search/search";
import {viewModesSwitching} from "../navigation/right-nav-bar";
import {hoverBuildingLabel, hoverOutBuildingLabel} from "../building-switch/buildingLabels";
import { Cylinder } from '../mode/cylinder';
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import { Box3 } from 'three';
import { Vector3 } from 'three';
import { getCurrentCameraDistance, getWorldData, rotateToCamera } from '../controls/orbitControls';
import { Matrix4 } from 'three';
import { Sphere } from 'three';
import { SphereBufferGeometry } from 'three';
import { MeshStandardMaterial } from 'three';
import { Mesh } from 'three';
import { BoxBufferGeometry } from 'three';
import { BoxHelper } from 'three';
import { BufferGeometry } from 'three';
import { LineBasicMaterial } from 'three';
import { Line } from 'three';
import { updateHoverPosition } from '../building-switch/buildingHover';
import { isDesktopMode } from '../language/langSwitcher';
import { doubleEventCheck } from '../controls/mouse-n-touches';
import { Amenities } from '../amenities/Amenities';
import { setDataToAmenities } from './autoSelectionBoxes';

let {selectedObject, hoveredObject} = settingsData;


let lastCheck = 0

export function checkIntersection(action) {
    /*
        let t = performance.now()
        let delta = t-lastCheck
        if (delta<30){
            return
        }
        lastCheck = t
    */
    let canvas = document.getElementById('c')

    if (!threeJsVariables.orbitControls.enabled || !canvas || settingsData.intersectionBlock) {
        hideTooltip();
        return;
    }

    let intersects = []
    /*
    if (settingsData.activeViewMode === ViewMode.Orbit) {

        let distance = Infinity
        let result = null
        for (let i=0;i<settingsData.box_to_intersection.length;i++){
            let o = settingsData.box_to_intersection[i]
            let r = threeJsVariables.raycaster.ray.intersectsBox(o)
            let dist = o.distanceToPoint(threeJsVariables.raycaster.ray.origin)
            if (r && dist<distance){
                distance = dist
                result = threeJsVariables.scene.getObjectByName('Project Buildings').children.find(e=>e.name===o.name)
            }
        }
        if (result!==null){
            intersects.push({ object: result.children[0] }) //
        }
    }else{
    */
    intersects = threeJsVariables.raycaster.intersectObjects(settingsData.objects_to_intersection, false);
    //}


    if (intersects.length > 0) {
        if (!isMobile && !settingsData.customCursor){
            canvas.style.cursor = 'pointer'
        }
        if (settingsData.selectedObject !== intersects[0].object) {
            settingsData.selectedObject = intersects[0].object;
            intersectionMouseOverHandler(settingsData.selectedObject);
        } else if (action === 'click') {
        // if (action === 'click') {

            doubleEventCheck(intersects[0].object);

            if (settingsData.activeViewMode === ViewMode.Orbit){
                // enterToTheCylinderMode();
                projectMode.Cylinder.enter(settingsData.selectedObject);

            } else {
                intersectionClickHandler(settingsData.selectedObject);
                if (settingsData.selectedObject.userData.type === "selectionBoxes") {
                    settingsData.isFlat = true;
                }
            }

            // enterToTheCylinderMode();

        }

    } else {
        if (!isMobile && !settingsData.customCursor){
            canvas.style.cursor = 'default'
        }
        if (settingsData.selectedObject) {
            switch (settingsData.selectedObject.userData?.type) {
                case SelectedObjectType.Building:
                    buildingHoverOut();
                    break;
                case SelectedObjectType.SelectionBoxes:
                    selectionBoxesSetStatusColor(settingsData.selectedObject, 'hoverOut');
                    break;
            }
            settingsData.selectedObject = null;
            settingsData.isFlat = false;
        }
    }

    cylinderFloorNumbersIntersection(action);
}


function buildingHover(pickedObject) {
    if (projectMode.LiteMode.isActive()) return;

    if (pickedObject === undefined) {
        buildingHoverOut();
        return;
    }
    buildingHoverOut();

    if (settingsData.activeViewMode === ViewMode.Orbit) {
        const {isActive, effectFXAA} = settingsData.postProcessing;
        const pickedBuilding = pickedObject.parent;

        const buildingInfo = Buildings.getBuilding(pickedBuilding.name);

        if (buildingInfo && Object.keys(buildingInfo.info).length) {
            const buildingLabel = document.querySelector('.building-labels_wrapper[data-name="'+pickedBuilding.name+'"]');
            buildingLabel.classList.add('building__hovered');

            const labelOnScene = threeJsVariables.scene.getObjectByName(buildingLabel.getAttribute('data-label'));

            settingsData.customCursor = true;

            updateHoverPosition(pickedBuilding,labelOnScene.position.y / 2,'show');

            if (isActive && effectFXAA) {
                threeJsVariables.outlinePass.selectedObject = pickedObject;
            }

            // const geometry = pickedObject.geometry.clone();
            // const edges = new THREE.EdgesGeometry( geometry );
            // const line = new THREE.LineSegments( edges, new THREE.LineBasicMaterial( { color: 0xffffff } ) );
            // line.position.copy(pickedObject.position);
            // pickedBuilding.add( line );

            // console.log(threeJsVariables.outlinePass);
            // pickedObject.material.emissive.setHex(0xffffff);
            // pickedObject.material.emissiveIntensity = 0.4;
            buildingInfo.mouseHover = true;
            // hoverBuildingLabel();
        }
    }
}

export function buildingHoverOut() {
    const {isActive, effectFXAA} = settingsData.postProcessing;
    const buildingHover = Buildings.getBuildingsArray().find(building => building.mouseHover);
    if (buildingHover) {
        // const buildingOnScene = threeJsVariables.scene.getObjectByName(buildingHover.name);
        const buildingLabel = document.querySelector('.building-labels_wrapper.building__hovered');

        settingsData.customCursor = false;

        updateHoverPosition(null,null,'hide');

        if (isActive && effectFXAA) {
            threeJsVariables.outlinePass.selectedObject = null;
        }
        // buildingOnScene.children[0].material.emissive.setHex(0x000000);
        // buildingOnScene.children[0].material.emissiveIntensity = 1;
        buildingLabel && buildingLabel.classList.remove('building__hovered');
        buildingHover.mouseHover = false;
    }
    // hoverOutBuildingLabel();
}

export async function intersectionClickHandler(selectedObject) {
    if (settingsData.buildingDestroyed && selectedObject.userData?.customSelection) return;

    if (userPrevent()) return;

    const unitCard = UnitCardClass.findCard()?.html;
    if (selectedObject.userData?.type !== SelectedObjectType.SelectionBoxes) {
        return;
    }

    // if (unitCard) {
    //     for (let i = 0; i < UnitCardClass.cards.length; i++) {
    //         if (UnitCardClass.cards[i].engineId === selectedObject.userData.crm_data.engineId) {
    //             console.log('block')
    //             // settingsData.doubleClick = false;
    //             return;
    //         }
    //     }
    // }

    Amenities.unselectAmenities();
    hoverOutPreviousSelection(unitCard);

    if (settingsData.buildingDestroyed) {
        selectionBoxesSetStatusColor(selectedObject, 'lock');
    }

    selectionBoxesSetStatusColor(selectedObject, 'click');

    await flatClick(selectedObject, config);

    // if (document.querySelector('.search__result-list')) {
        // changeActiveCardWhenBuildingClick(selectedObject);
    // }
}

function intersectionMouseOverHandler(selectedObject) {
    if (!selectedObject.userData?.isClicked) {
        switch (selectedObject.userData?.type) {
            case SelectedObjectType.Building:
                buildingHover(selectedObject);
                break;
            case SelectedObjectType.SelectionBoxes: {

                hoveredObject !== null && selectionBoxesSetStatusColor(hoveredObject, 'hoverOut');
                selectionBoxesSetStatusColor(selectedObject, 'hover');
                break;
            }
        }
    } else {
        hoveredObject && selectionBoxesSetStatusColor(hoveredObject, 'hoverOut');
    }
}

// export function enterToTheCylinderMode(tower) {
//     if (settingsData.activeViewMode !== ViewMode.Orbit) return;
//     const activeTower = tower || buildings_info.find(tower => tower.name === selectedObject.parent.name);
//
//     if (settingsData.isTouchEvent && settingsData.isDesktopMode) { // FOR DESKTOP
//         if (activeTower && settingsData.doubleClick) {
//             activeTower.isActive = true;
//             viewModesSwitching(ViewMode.Cylinder);
//         }
//     } else if (activeTower && settingsData.isClickEvent) { // FOR WEB
//         activeTower.isActive = true;
//         viewModesSwitching(ViewMode.Cylinder);
//     } else if (settingsData.isTouchEvent && !settingsData.isDesktopMode) { // FOR MOBILE & TABLETS
//         activeTower.isActive = true;
//         viewModesSwitching(ViewMode.Cylinder);
//     } else if (activeTower && tower){ /// FOR MENU SEARCH CLICK
//         activeTower.isActive = true;
//         viewModesSwitching(ViewMode.Cylinder);
//     }
// }

export function selectionBoxesSetStatusColor(selectedObject, action, tooltipFlag,customColor) {

    if (!selectedObject || selectedObject.name.startsWith(config.resources.selectionBoxes.floorPlugName)) return;

    const {colorStatus, opacity} = config.threejs.selectionBoxes;
    const activeBuilding = Buildings.getActiveBuilding();

    if (!activeBuilding) return;

    const crmDataObject = activeBuilding.info.crm_data.find(apt => selectedObject.name === apt.engineId);
    const objectStatus = (crmDataObject) ? crmDataObject.status.toLowerCase() : 'available';
    const color = colorStatus.find(c => c.status === objectStatus);

    switch (action) {
        case 'hover': {
            if (isMobile || settingsData.isDesktopMode) return;

            if (selectedObject.userData.customSelection){
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);

                selectedObject.material.color.setHex(`0x${customColor}`);
                selectedObject.material.opacity = opacity.hover;
                hoveredObject = selectedObject;

            } else {
                selectedObject.material.color.setHex(`0x${color.hover}`);
                selectedObject.material.opacity = opacity.hover;
                hoveredObject = selectedObject;

            }

            // selectedObject.material.color.setHex(`0x${color.hover}`);
            // selectedObject.material.opacity = opacity.hover;
            // hoveredObject = selectedObject;

            if (!settingsData.buildingDestroyed) {
                updateTooltipText(selectedObject, crmDataObject);
                settingsData.lastHoverObject = updateTooltipPosition(threeJsVariables.mouse.winY, threeJsVariables.mouse.winX, hoveredObject);
            }
            break;
        }
        case 'hoverOut': {
            if (!selectedObject.userData.isClicked) {
                selectedObject.material.color.setHex(`0x${color.basic}`);
                selectedObject.material.opacity = (selectedObject.userData?.isActive) ? opacity.basic : 0;
            }

            if (hoveredObject && !hoveredObject.userData.isClicked) {
                hoveredObject.material.color.setHex(`0x${color.basic}`);
                hoveredObject.material.opacity = (selectedObject.userData?.isActive) ? opacity.basic : 0;
                hoveredObject = null;

            }

            if (selectedObject.name.match(/_amenity_/g)) {
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);
                selectedObject.material.color.setHex(`0x${customColor}`);
            }

            if (isMobile || tooltipFlag) return;
            hideTooltip();
            break;
        }

        case 'amenityHover':{
            selectedObject.material.color.setHex(`0x${customColor}`);
            selectedObject.material.opacity = opacity.hover;

            break;
        }
        case 'click': {

            if (selectedObject.userData.customSelection){
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);

                selectedObject.material.color.setHex(`0x${customColor}`);

            } else {
                selectedObject.material.color.setHex(`0x${color.active}`);
            }

            selectedObject.userData.isClicked = true;
            selectedObject.material.opacity = opacity.hover;
            settingsData.lastClickedFlat = selectedObject;
            return;
        }
        case 'lock': {
            selectedObject.userData.isActive = true;

            if (!selectedObject.userData.isClicked || !selectedObject.userData.isInSearch) {
                selectedObject.material.opacity = opacity.basic;
                selectedObject.material.color.setHex(`0x${color.basic}`);
            }

            break;
        }
        case 'unlock': {

            if (!selectedObject.userData.isInSearch) {
                selectedObject.userData.isActive = false;
                selectedObject.material.color.setHex(`0x${color.basic}`);
                selectedObject.material.opacity = 0;
            }

            if (selectedObject.name.match(/_amenity_/g)) {
                const customColor = rgbaToHexA(config.style.colors.find(color => color.key === 'brand2').value.split(','),false).substring(1);
                selectedObject.material.color.setHex(`0x${customColor}`);
            }

            break;
        }
        default: {
            break;
        }
    }
}

export const hoverOutPreviousSelection = (unitCard) => {
    if (!unitCard) return;
    let activeCard;

    if (settingsData.lastClickedFlat) {
        if (cardsData.multiplyCards) {
            activeCard = UnitCardClass.cards.length > 1 && UnitCardClass.findCard(false, 'active').html.getAttribute('data-engineid');
        } else {
            activeCard = unitCard.getAttribute('data-engineid');
        }

        if (activeCard) {
            const {selectedMesh} = findSelectionAndCrmData(activeCard);
            selectedMesh.userData.isClicked = false;
            selectionBoxesSetStatusColor(selectedMesh, 'hoverOut');
        }
    }
}